module.exports = __webpack_public_path__ + "img/47.952bd605.jpg";